import moment from 'moment-timezone'
import { ClosingDay } from '@/types/ClosingDays'
import { CalendarEventType, EventCalendar } from '@/types/Calendar'

export function dataClosingDays(closingDays: ClosingDay[]): EventCalendar[] {
    return closingDays.map((closingDay: ClosingDay) => {
        return {
            title: closingDay.closingDaysReason,
            start: moment(closingDay.startDate, 'DD-MM-YYYY').startOf('day').toDate(),
            end: moment(closingDay.endDate, 'DD-MM-YYYY').endOf('day').toDate(),
            number: '',
            type: CalendarEventType.CLOSING_DAY,
            slots: closingDay
        }
    })
}
